module.exports = __webpack_public_path__ + "media/exterieur12h.93409853.mp4";